var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0375,
    cy: 31.4627,
    r: 21.2836,
    fill: "#F04B4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9844 26H20.9844C20.3213 26 19.6854 26.2634 19.2166 26.7322C18.7478 27.2011 18.4844 27.837 18.4844 28.5V33.5C18.4844 34.163 18.7478 34.7989 19.2166 35.2678C19.6854 35.7366 20.3213 36 20.9844 36H22.2344V41C22.2344 41.3315 22.3661 41.6495 22.6005 41.8839C22.8349 42.1183 23.1529 42.25 23.4844 42.25H25.9844C26.3159 42.25 26.6338 42.1183 26.8683 41.8839C27.1027 41.6495 27.2344 41.3315 27.2344 41V36H30.9844L37.2344 41V21L30.9844 26ZM42.8594 31C42.8594 33.1375 41.6594 35.075 39.7344 36V26C41.6469 26.9375 42.8594 28.875 42.8594 31Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.f2821045d77adc56e5ae95e81be55b87.svg";
export { ForwardRef as ReactComponent };